import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import strings from '../../../Globalization';
import DigitalGraph from '../../../components/common/DigitalGraph';
import ThermometerChart from '../../../components/common/Thermometer';
import GaugeChart from '../../../components/common/charts/GaugeChart';
import consts from '../../../consts';
import { useCycleInfo } from '../../../contexts/CycleInfo/Context';

const ThermalDecontam = ({ property = 'THERMALDECONTAM_1', propertyName = 'THERMALDECONTAM' }) => {
	const theme = useTheme();
	const { data: cycle } = useCycleInfo();
	const data = cycle.ChartDetail[property];
	
	const isEnspire = cycle.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;
	const maxLimit = parseFloat(data.Thermal.Pressure.MaxLimit);
	const minReqPress = parseFloat(data.Thermal.Pressure.MinReqPress);
	const middleLimit = parseFloat(data.Thermal.Pressure.MiddleLimit);
	const minLimit = parseFloat(data.Thermal.Pressure.MinLimit);
	const minPressRec = parseFloat(data.Thermal.Pressure.MinPressRec);
	const upperLimit = minPressRec > minReqPress ? minPressRec + 10 : minReqPress + 10;

	return (
		<Grid container>
			<Grid size={12}>
				<Card>
					<CardContent sx={{ paddingTop: 4, paddingBottom: 4 }}>
						<Grid container>
							<Grid size={12} display={'flex'} flexDirection={'column'} gap={2}>
								<Divider />
								<Typography variant="subtitle2">
									{data.Thermal.ThermalRinseA0 === 'None' ? '' : data.Thermal.ThermalRinseA0}
								</Typography>
								<Typography variant="subtitle2">{strings[propertyName]}</Typography>
								<Divider />
							</Grid>
							<Grid size={{xs: 12, md: 4}}  paddingTop={2}>
								<ThermometerChart
									title={strings.Temperature}
									minValue={data.Thermal.Temperature.MinTempRec}
									maxValue={data.Thermal.Temperature.MaxTempRec}
									lowerLimit={data.Thermal.Temperature.TempSetPt1}
									upperLimit={data.Thermal.Temperature.MaxCycleTemp}
									unit={data.Thermal.Temperature.Unit}
								/>
							</Grid>
							<Grid size={{xs: 12, md: 4}}  paddingTop={2}>
								<Box display={'flex'} alignItems={'center'} flexDirection={'column'}>
									<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
										{strings.Pressure}
									</Typography>
									<Typography variant="subtitle2" flex={1}>
										{data.Thermal.Pressure.Unit}
									</Typography>
								</Box>
								<Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
									<GaugeChart
										min={minLimit}
										max={isEnspire ? consts.GaugeChart.MaxScale : maxLimit+10}
										value={minPressRec}
										tickCount={21}
										startAngle={-90}
										endAngle={90}
										labelTickCount={5}
										pointerLabel={data.Thermal.Pressure.Unit}
										uom={minPressRec}
										segments={[
											{
												min: minLimit,
												max: minReqPress,
												color: theme.palette.error.light
											},
											{
												min: minReqPress,
												max: isEnspire ? consts.GaugeChart.MidScale : middleLimit,
												color: theme.palette.success.light
											},
											{
												min: isEnspire ? consts.GaugeChart.MidScale : middleLimit,
												max: isEnspire ? consts.GaugeChart.MaxScale : maxLimit+10,
												color: theme.palette.error.light
											}
										]}
									/>
								</Box>

							</Grid>
							<Grid size={{xs: 12, md: 4}}  paddingTop={2}>
								<Typography variant="subtitle2" textAlign={'center'}>
									{strings.FillingPortPure}
									{isEnspire && data.Thermal.Time.WaterPort === consts.WasterPort.FilteredWater
										? strings.FilteredWater
										: data.Thermal.Time.WaterPort}
								</Typography>
								<DigitalGraph title={strings.SetTime} value={data.Thermal.Time.SetTime} />
								<DigitalGraph title={strings.RecordedTime} value={data.Thermal.Time.RecordedTime} />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default memo(ThermalDecontam);
